import type { Post } from "./types";
import { POSTS_1 } from "./part1";
import { POSTS_2 } from "./part2";
import { POSTS_3 } from "./part3";
import { POSTS_4 } from "./part4";
import { POSTS_5 } from "./part5";
import { POSTS_6 } from "./part6";
import { POSTS_7 } from "./part7";
import { POSTS_8 } from "./part8";
import { POSTS_9 } from "./part9";
import { POSTS_10 } from "./part10";
import { POSTS_11 } from "./part11";
import { POSTS_12 } from "./part12";
import { POSTS_13 } from "./part13";
import { POSTS_14 } from "./part14";
import { POSTS_15 } from "./part15";
import { POSTS_16 } from "./part16";
import { POSTS_17 } from "./part17";
import { POSTS_18 } from "./part18";
import { POSTS_19 } from "./part19";

export const POSTS: Record<string, Post> = {
  ...POSTS_1,
  ...POSTS_2,
  ...POSTS_3,
  ...POSTS_4,
  ...POSTS_5,
  ...POSTS_6,
  ...POSTS_7,
  ...POSTS_8,
  ...POSTS_9,
  ...POSTS_10,
  ...POSTS_11,
  ...POSTS_12,
  ...POSTS_13,
  ...POSTS_14,
  ...POSTS_15,
  ...POSTS_16,
  ...POSTS_17,
  ...POSTS_18,
  ...POSTS_19,
};


export type { Post, Block } from "./types";
